<template>
  <v-card>
    <v-toolbar
      color="primary"
      class="toolbar"
    >
      <div
        class="touche gris"
        style="width:36px;height:36px;"
      >
        <span class="signe" />
      </div>

      <v-toolbar-title class="ml-0">
        Touche raccourci
      </v-toolbar-title>
    </v-toolbar>
    <div class="body-2 px-2 mt-3 d-flex">
      {{ $t('info.shortcut_customization') }}
      <br>{{ $t('info.shortcut_memorization') }}
    </div>
    <v-divider />

    <div class="d-flex pa-3">
      <span class="subheading ml-3">{{ $t('info.functionality') }}</span>
      <v-spacer />
      <span class="subheading mr-3">{{ $t('info.favorite') }}</span>
    </div>
    <v-divider />

    <v-container class="bloc-action-small">
      <v-layout
        v-for="(item, index) in menuItems"
        :key="index"
        class="my-3 pl-2"
      >
        <v-flex xs8>
          <v-btn
            class="bloc"
            outlined
            @click="$emit('action', index)"
          >
            <v-icon class="mr-3">
              {{ item.icon }}
            </v-icon>
            {{ $t(item.text) }}
          </v-btn>
        </v-flex>
        <v-flex
          xs3
          offset-xs1
          class="text-center"
        >
          <v-btn
            class="btn"
            icon
            @click="save(index)"
          >
            <v-icon
              large
              :color="index === favorite ? 'yellow' : 'grey'"
            >
              {{ IconEnum.star }}
            </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>

    <div class="info-card bottom-card align-card">
      <v-icon>{{ IconEnum.info }}</v-icon>
      <span>{{ $t('info.change_preference') }}</span>
    </div>

    <bottom-action
      @del="$emit('hide')"
    />
  </v-card>
</template>

<script>
import { MetierLocalStorage } from 'modulelocalstorage'
import { IconEnum } from '@/modules/Enums'

export default {
  name: 'ActionMenu',

  data () {
    return {
      IconEnum
    }
  },

  computed: {
    favorite: {
      get () { return this.$store.state.favoriteItem },
      set (val) {
        MetierLocalStorage.setFavoriteItem(val)
        this.$store.commit('favoriteItem', val)
      }
    },
    menuItems () {
      return this.$store.state.menuItems
    }
  },

  methods: {
    save (index) {
      // Sauvegarde du favori
      this.favorite = index
      // Lancement de l'action associée
      this.$emit('action', index)
    }
  }
}
</script>
